import React, { useState, useEffect, ChangeEvent } from 'react';
import moment from 'moment';
import { simpleGTMDataLayer } from '../../util/GTMHelpers';
import { GreenCalendar, AltInfo, Success } from '../../icons';
import {
  Label,
  Input,
  Text,
  ChangeForm,
  InputGroup,
  EffectiveDateDivWithIcon,
  BelowEffectiveDateDiv,
  GreenCalendarDiv,
  ButtonContainer,
  CancelButton,
  StartChangeButton,
  SelectButton,
  SelectFiles,
  DocumentBox,
  DocumentName,
  DocumentText,
  ErrorMessage,
  TextArea,
  DatePickerRow,
  Loading,
  PolicyTermContainer,
  PolicyTermInfoWrap,
  InfoIcon,
  PolicyTermInfoText,
  PolicyTermTitle,
  PolicyTermOption,
  PolicyTermOptionsRadio,
  PolicyTermOptionsLabel,
  DescriptionTextOptional,
  DatePickerWrapper,
  DatePickerModalBackground,
  Checkbox,
  CheckboxText,
  CheckboxOverallContainer,
  CheckboxIndividualContainer,
  CheckboxContainer,
  IconDiv,
  CheckboxLabel
} from './changePolicyStyles';
import SuccessMessage from './successMessage';
import { ReactComponent as OrangeAlertTriangle } from '../../assets/images/OrangeAlertTriangle.svg';
import spinnerLight from '../../assets/images/spinner-light.svg';
import { formatDate } from '../../util/formatters';
import { MAKE_A_POLICY_CHANGEVariables } from './graphql/__generated__/MAKE_A_POLICY_CHANGE';
import DatePicker from '../datePicker';
import { GET_CHANGE_POLICY_INFO_account_items_policy_valid_policy_change_messages } from './graphql/__generated__/GET_CHANGE_POLICY_INFO';
import { CommercialUmbrellaURLMessage } from '.';
import ErrorModal from './errorModal';
import { BannerText, DownloadDocumentBanner } from '../cancelPolicy/cancelPolicyForm/formFields/cancelReasonStyles';
import AlertModal from '../gpaCancelPolicy/AlertModal';
import { SecurityOption, SecuritySelector, SelectorContainer } from '../cancelPolicy/cancelPolicyForm/cancelPolicyFormStyles';
import { Container, GrayBox, MainText } from './successMessageStyles';
import Header from '../header/Header';
import { ElementWrap, WarningText } from '../gpaCancelPolicy/RefundMethodsStyles';
import { Warning } from '@material-ui/icons';
import { termObj } from './DataContainer';
import { SuccessIcon } from '../../stories/Icons.stories';
import { convertToUtc } from '../../util/dateConvertToUTC';

const policyTermOptionsArr = ['Current Term', 'Current and Renewal Term'];

interface changeFormProps {
  changePolicy: Function;
  isOpen: boolean;
  policyNumber: string;
  accountNumber: string;
  maxEffectiveDate?: string | number | Date | null | undefined;
  minEffectiveDate?: string | undefined | null;
  policyType: string | undefined;
  clChangeWithDocument: Function;
  setIsOpen: Function;
  renewalDate: string | null;
  status: string | undefined | null;
  returnedMessage?:
  | (GET_CHANGE_POLICY_INFO_account_items_policy_valid_policy_change_messages | null)[]
  | null;
  isLoading: boolean;
  setIsLoading: Function;
  multipleChangesIndicator: boolean | undefined;
  isFarmPolicy: boolean;
  isCppLine: boolean;
  isWorkerCompLine: boolean;
  isCommercialLine: boolean;
  latestPolicy: any;
  periods: any;
  line: string;
  query_env: string;
  source_system_code: string;
  uploadToken: string;
  laterRenewalExists: boolean;
  activePolicyChanges: boolean;
  setRunSubscription: Function;
  changeResponse: any;
  uploadDoc: Function;
  uploadError: any;
  openChanges: boolean;
  renewalTerms: termObj[];
  showRenewal: boolean;
  migrated: boolean;
}

interface ErrorsProps {
  effectiveDate?: boolean;
  validateEffectiveDate?: boolean;
  description?: boolean;
  file?: boolean;
  api?: boolean;
  changeType?: boolean;
  security?: boolean;
  renewalTerm?: boolean;
  migrated?: boolean;
}

export default ({
  changePolicy,
  isOpen,
  policyNumber,
  policyType,
  clChangeWithDocument,
  setIsOpen,
  renewalDate,
  accountNumber,
  minEffectiveDate,
  maxEffectiveDate,
  status,
  returnedMessage,
  isLoading,
  setIsLoading,
  multipleChangesIndicator,
  isFarmPolicy,
  isCppLine,
  isWorkerCompLine,
  isCommercialLine,
  latestPolicy,
  periods,
  line,
  query_env,
  source_system_code,
  uploadToken,
  laterRenewalExists,
  activePolicyChanges,
  setRunSubscription,
  changeResponse,
  uploadDoc,
  uploadError,
  openChanges,
  renewalTerms,
  showRenewal,
  migrated
}: changeFormProps) => {
  const [displaySuccessMessage, setDisplaySuccessMessage] = useState<boolean>(
    false
  );
  const [effectiveDate, setEffectiveDate] = useState('');
  const [description, setDescription] = useState('');
  const [effectiveDateInputSelected, setEffectiveDateSelected] = useState(
    false
  );
  const [descriptionInputSelected, setDescriptionSelected] = useState(false);
  const [documentInputSelected, setDocumentSelected] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [errors, setErrors] = useState<ErrorsProps>({});
  const [newDate, setNewDate] = useState(1);
  const [showCalendar, setShowCalendar] = useState(false);
  const [showError, setShowError] = useState(false);
  const [policyTerm, setPolicyTerm] = useState<string>(
    renewalDate ? policyTermOptionsArr[1] : policyTermOptionsArr[0]
  );
  const [
    businessownersChangeChoices,
    setBusinessOwnersChangeChoices
  ] = useState([false, false, false, false, false]);
  const [applyChangeToRenewal, setapplyChangeToRenewal] = useState([false, false]);
  const [spinnerText, setSpinnerText] = useState<string>('UPLOADING');
  const [effectiveDateErrorMessage, setEffectiveDateErrorMessage] = useState<string>('');
  const [showRenewalMessage, setShowRenewalMessage] = useState<Boolean>(false);
  const [securityType, setSecurityType] = useState<string>('');
  const [docUploadSuccess, setDocUploadSuccess] = useState(false);
  const [renewalTermError, setRenewalTermError] = useState(false);
  const [effectiveDtRenewalError, setEffectiveDtRenewalError] = useState(false);
  useEffect(() => {
    if (changeResponse) {
      if (changeResponse?.createTime && changeResponse?.uwactivityCreated)
        setDisplaySuccessMessage(true);
    }
  }, [changeResponse]);


  useEffect(() => {
    if (showCalendar) {
      setShowCalendar(!showCalendar);
    }
    if (line &&
      (line === "FULine" || line === "FALine" || line === "FRMLine" || line === "WC7Line") &&
      minEffectiveDate
    ) {
      const showEffectiveDate = moment(minEffectiveDate, "YYYY-MM-DD").format("MM/DD/YYYY");
      // setEffectiveDate(minEffectiveDate)
    }
  }, [effectiveDate, minEffectiveDate]);

  useEffect(() => {
    setDescription('');
  }, [policyNumber]);

  useEffect(() => {
    if (laterRenewalExists) {
      setShowRenewalMessage(laterRenewalExists);
    }
  }, [laterRenewalExists]);

  let documentNeeded = false;
  const isMarketUmbrella = !!(policyType === 'Middle Market Umbrella');
  const getDocumentContents: Function = (f: File) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(f);
      reader.onload = () => resolve(reader.result);
      reader.onerror = err => {
        reject(err);
        return null;
      };
    });
  if (isWorkerCompLine || isCppLine || line === "FULine") {
    documentNeeded = true;
  }
  if (
    policyType === 'WORKERS COMP' ||
    policyType === 'COMMERCIAL PACKAGE' ||
    policyType === 'COMMERCIAL PROPERTY' ||
    policyType === 'COMMERCIAL GENERAL LIABILITY' ||
    policyType === 'General Liability'
  ) {
    documentNeeded = true;
  }
  const validateEffectiveDate = () => {
    let dateErrorMessage: string = '';
    let invalidEffectiveDate: boolean = false;
    if (effectiveDate !== undefined && minEffectiveDate !== undefined && maxEffectiveDate !== undefined) {
      try {
        const tmpDateEffectiveMnt = moment(effectiveDate, "YYYY-MM-DDTHH:mm:SSZ");
        if (tmpDateEffectiveMnt.isValid()) {
          var pastEffectiveDateMsg, futureEffectiveDateMsg;
          if (isCppLine || isWorkerCompLine) {
            pastEffectiveDateMsg = "Effective Date must be on or after inception date";
            futureEffectiveDateMsg = latestPolicy?.canceled ? "Effective Date must be before expiration date" : "Effective Date must be on or before expiration date";
          } else {
            pastEffectiveDateMsg = "Effective date is too far in the past, please select a date that is equal to or greater than " + moment(minEffectiveDate).format("MM/DD/YYYY");
            futureEffectiveDateMsg = "Effective date is too far in the future, please select a date that is less than or equal to " + moment(maxEffectiveDate).format("MM/DD/YYYY");
          }
          const tmpDateEffective = tmpDateEffectiveMnt.toDate();
          const tmpDateMaxFuture = moment().add(30, 'days');
          tmpDateEffective.setHours(0, 0, 0, 0);
          if (tmpDateEffective.getTime() < moment(minEffectiveDate, 'YYYY-MM-DDTHH:mm:SSZ').toDate().getTime()) {
            invalidEffectiveDate = true;
            dateErrorMessage = pastEffectiveDateMsg;
          } else if (isCommercialLine && tmpDateEffective.getTime() > tmpDateMaxFuture.toDate().getTime()) {
            invalidEffectiveDate = true;
            dateErrorMessage = "Effective Date is too far in the future";
          } else if (tmpDateEffective.getTime() > moment(maxEffectiveDate, 'YYYY-MM-DDTHH:mm:SSZ')?.toDate().getTime()) {
            invalidEffectiveDate = true;
            dateErrorMessage = futureEffectiveDateMsg;
          } else {
            invalidEffectiveDate = false;
            dateErrorMessage = "";
          }
        } else {
          invalidEffectiveDate = true;
          dateErrorMessage = "Effective Date must be a valid date in the format \"MM/DD/YYYY\"";
        }
      } catch (Exception) {
        invalidEffectiveDate = true;
        dateErrorMessage = "Effective Date must be a valid date in the format \"MM/DD/YYYY\"";
      }
    } else if (effectiveDate === undefined) {
      invalidEffectiveDate = true;
      dateErrorMessage = "Effective Date must be a valid date in the format \"MM/DD/YYYY\"";
    }
    setEffectiveDateErrorMessage(dateErrorMessage);
    return invalidEffectiveDate;
    // return (
    //   effectiveDate &&
    //   minEffectiveDate &&
    //   maxEffectiveDate &&
    //   effective.isBetween(min, max)
    // );
  };

  const termBetweenValidation = (dateToValidate: any, termToValidate: termObj) => {
    const minDt = moment(termToValidate.minDate, "MM/DD/YYYY");
    const maxDt = moment(termToValidate.maxDate, "MM/DD/YYYY");
    if (!!dateToValidate && !!minDt && !!maxDt) {
      return (dateToValidate.isSame(minDt) || dateToValidate.isSame(maxDt) || dateToValidate.isBetween(minDt, maxDt));
    }
    return false;
  };

  const validateRenewalTerm = () => {
    setErrors({});
    let invalidRenewalDate: boolean = false;
    let invalidEffectiveDate: boolean = false;
    if (!!renewalTerms && renewalTerms.length > 1 && effectiveDate !== undefined && isCommercialLine) {
      let selectedEffDate = moment(effectiveDate);
      invalidRenewalDate = !(renewalTerms[0].isSelected || renewalTerms[1].isSelected);
      if (!invalidRenewalDate) {
        if (renewalTerms[0].isSelected && renewalTerms[1].isSelected) {
          invalidEffectiveDate = !termBetweenValidation(selectedEffDate, renewalTerms[0]);
        } else {
          if (renewalTerms[0].isSelected && !renewalTerms[1].isSelected) {
            invalidEffectiveDate = !(termBetweenValidation(selectedEffDate, renewalTerms[0]));
          }
          if (renewalTerms[1].isSelected && !renewalTerms[0].isSelected) {
            invalidEffectiveDate = !(termBetweenValidation(selectedEffDate, renewalTerms[1]));
          }
          // invalidEffectiveDate = !(termBetweenValidation(selectedEffDate, renewalTerms[0]) ||
          // termBetweenValidation(selectedEffDate, renewalTerms[1]));
        }
      } else {
        invalidEffectiveDate = false;
      }
    }
    setRenewalTermError(invalidRenewalDate);
    setEffectiveDtRenewalError(invalidEffectiveDate);
    return (!invalidRenewalDate && !invalidEffectiveDate);
  };
  const makeAPolicyChange = () => {
    setErrors({});
    const updatedErrors: ErrorsProps = {};
    if (validateEffectiveDate()) updatedErrors.validateEffectiveDate = true;
    if (!!showRenewal && !migrated && !validateRenewalTerm()) updatedErrors.renewalTerm = true;
    if (!description) updatedErrors.description = true; //TODO
    if ((line === 'CA7Line' || line === 'CULine' || line === 'BP7Line') && businessownersChangeChoices.every(value => value === false)) updatedErrors.changeType = true;
    if (Object.keys(updatedErrors).length) {
      setErrors(updatedErrors);
      return;
    }
    setSpinnerText('PROCESSING NOW');
    setIsLoading(true);
    const variables: MAKE_A_POLICY_CHANGEVariables = {
      policy_number: policyNumber,
      effective_date: `${convertToUtc(effectiveDate)}`,
      description,
      businessowners_options: businessownersChangeChoices,
      source_system_code: source_system_code,
      query_env: query_env,
      status: status,
      policyBusinessLine: line
    };
    if (renewalDate)
      variables.apply_change_to_renewal =
        policyTerm === 'Current and Renewal Term';
    changePolicy({
      variables
    });
    if (renewalTerms)
      variables.apply_change_to_renewal = applyChangeToRenewal[1];
    changePolicy({
      variables
    });
    simpleGTMDataLayer({
      event: 'changePolicyClick',
      event_action: 'Button Click',
      event_category: window.location.pathname,
      event_label: 'changePolicy'
    });
    simpleGTMDataLayer({
      event: 'changePolicyClickSnowplow',
      event_action: 'Button Click',
      event_category: window.location.pathname + '/Snowplow',
      event_label: 'changePolicy'
    });
  };

  const showDocumentError = errors.file && !file;
  const showDescriptionError = errors.description && !description.length;
  const showEffectiveDateError = errors.effectiveDate && !effectiveDate.length;
  const showRenewlPeriodError = errors.renewalTerm;

  const uploadDocumentAndChangePolicy: Function = async () => {
    simpleGTMDataLayer({
      event: 'changePolicyClick',
      event_action: 'Button Click',
      event_category: window.location.pathname,
      event_label: 'changePolicy'
    });
    simpleGTMDataLayer({
      event: 'changePolicyClickSnowplow',
      event_action: 'Button Click',
      event_category: window.location.pathname + '/Snowplow',
      event_label: 'changePolicy'
    });
    setErrors({});
    const updatedErrors: ErrorsProps = {};
    if (!effectiveDate) updatedErrors.effectiveDate = true;
    if (validateEffectiveDate()) updatedErrors.validateEffectiveDate = true;
    if (!description) updatedErrors.description = true;
    if (!file) updatedErrors.file = true;
    if (isMarketUmbrella && !securityType) updatedErrors.security = true;
    if (Object.keys(updatedErrors).length) {
      setErrors(updatedErrors);
      return;
    }
    setRunSubscription(policyNumber);
    setIsLoading(true);
    let documentData;
    if (file) documentData = await getDocumentContents(file);
    const policyChangeVariables = {
      variables: {
        document_data: documentData,
        file_name: file?.name,
        mime_type: file?.type,
        policy_number: policyNumber,
        description,
        policy_type: policyType,
        effective_date: `${convertToUtc(effectiveDate)}`,
        source_system_code: source_system_code,
        query_env: query_env,
        status: status,
        policyBusinessLine: line,
        uploadToken: uploadToken,
        apply_change_to_renewal: renewalTerms.length ? !!renewalTerms[1].isSelected : false,
      }
    };
    await clChangeWithDocument(policyChangeVariables)
      .then((response: any) => {
        const responseAttributes =
          response?.data?.commercialLinesPolicyChangeWithDocumentUpload;
        if (
          responseAttributes?.uw_activity_created === 'Activity Created' &&
          responseAttributes?.create_time
        ) {
          setIsLoading(false);
          setDisplaySuccessMessage(true);
        }
        if (
          responseAttributes?.uw_activity_created === 'Unable to create activity because of invalid ActivityPattern code.' &&
          responseAttributes?.create_time
        ) {
          setIsLoading(false);
          setDisplaySuccessMessage(true);
        }
        if (
          responseAttributes?.display_type === 'Cannot change policy: No period for this effective date') {
          setErrors({
            effectiveDate: true
          });
          setIsLoading(false);
          setEffectiveDate("");
        }
      })
      .catch((error: Error) => {
        if (!error.message.includes('Execution timed out.')) {
          setErrors({
            api: true
          });
          setIsLoading(false);
        }
        if (!error.message.toLowerCase().includes('invalid activity')) {
          setDisplaySuccessMessage(true);
          setIsLoading(false);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const uploadDocumentForChange: Function = async () => {
    setErrors({});
    const updatedErrors: ErrorsProps = {};
    if (!file) updatedErrors.file = true;
    if (!securityType) updatedErrors.security = true;
    if (Object.keys(updatedErrors).length) {
      setErrors(updatedErrors);
      return;
    }
    setIsLoading(true);
    try {
      let documentData;
      if (file) documentData = await getDocumentContents(file);
      await uploadDoc({
        variables: {
          policy_number: policyNumber,
          file_name: file?.name,
          mime_type: file?.type,
          document_type: 'letter_received',
          security_type: securityType,
          source_system_code: source_system_code,
          document_data: documentData,
          query_env: query_env,
          token: uploadToken || ""
        }
      }).then((response: any) => {
        setDocUploadSuccess(true);
        setIsLoading(false);
        setDisplaySuccessMessage(true);
      });
    } catch (err) {
      console.log('error uploading doc', err);
      setDocUploadSuccess(false);
      setIsLoading(false);
    } finally { setIsLoading(false); }
  };

  let useCustomErrorMessage = false;
  let customErrorMessage = '';

  if (
    status?.toUpperCase() === 'CANCELLED' ||
    status?.toUpperCase() === 'CANCELING'
  ) {
    useCustomErrorMessage = true;
    customErrorMessage = `Policy is ${status.toUpperCase() === 'CANCELLED'
      ? 'cancelled'
      : 'pending cancellation'
      }. Unable to start policy change.`;
  } else if (
    returnedMessage &&
    returnedMessage[0] &&
    returnedMessage[0].message &&
    returnedMessage[0]?.name === 'PolicyChangeRenewalError' &&
    returnedMessage[0].message[0]
  ) {
    useCustomErrorMessage = true;
    customErrorMessage = returnedMessage[0].message[0];
  } else if (errors.api) {
    customErrorMessage =
      'We were unable to process your request. Please try again later or contact your underwriter for assistance.';
  } else if (policyType === 'COMMERCIAL UMBRELLA') {
    useCustomErrorMessage = true;
    customErrorMessage = '';
  } else if (errors.validateEffectiveDate) {
    customErrorMessage = effectiveDateErrorMessage;
  } else if (errors.effectiveDate) {
    customErrorMessage = 'Cannot change policy: No period for this effective date.';
  } else {
    customErrorMessage = 'All the fields are required.';
  }

  return (
    <div>
      {showError && (
        <AlertModal
          showError={showError}
          setError={setShowError}
          errorMessage={'A policy change is active for this policy. Continue with current policy change or withdraw policy change.'}
        />
      )}
      <ChangeForm test-attr="change-policy-dropdown-frame">
        {displaySuccessMessage ? (
          isMarketUmbrella ? (
            <Container>
              <GrayBox>
                <span>
                  <Success />
                  <b> &nbsp; Document uploaded successfully.</b>
                </span>
              </GrayBox>
            </Container>) :

            (
              <SuccessMessage
                effectiveDate={effectiveDate}
                closeDropdown={setIsOpen}
              />
            )
        ) : (
          <>
            {(openChanges && isMarketUmbrella) && (
              <WarningText>
                <Warning />
                A policy change request is already in progress. Please review the incomplete policy change request before proceeding.
              </WarningText>
            )}
            {showRenewalMessage && (
              <DownloadDocumentBanner>
                <AltInfo />
                <BannerText>There is a later renewal. Apply this PolicyChange to that renewal.</BannerText>
              </DownloadDocumentBanner>
            )}
            {(Object.keys(errors).length > 0 ||
              useCustomErrorMessage === true) && (
                <ErrorMessage test-attr="policy-change-error-message">
                  <IconDiv>
                    <OrangeAlertTriangle />
                  </IconDiv>
                  <span test-attr="policy-change-error-message-text">
                    {customErrorMessage}
                    <CommercialUmbrellaURLMessage
                      returnedMessage={returnedMessage}
                      policyType={policyType}
                    />
                  </span>
                </ErrorMessage>
              )}
            {useCustomErrorMessage === false && (
              <div>
                {multipleChangesIndicator && (
                  <ErrorMessage>
                    <IconDiv>
                      <OrangeAlertTriangle />
                    </IconDiv>
                    <span test-attr="policy-change-multiple-changes-warning-message">
                      Please review the incomplete policy change transaction
                      prior to starting a new change.
                    </span>
                  </ErrorMessage>
                )}
                {!isMarketUmbrella && (<InputGroup>
                  <Label
                    active={effectiveDateInputSelected}
                    showError={showEffectiveDateError}
                  >
                    Effective Date
                  </Label>
                  <DatePickerRow>
                    <EffectiveDateDivWithIcon
                      showError={showEffectiveDateError}
                      test-attr="policy-change-effective-date-with-icon"
                      onChange={event => {
                        setEffectiveDate(event.target.value);
                      }}
                      value={effectiveDate}
                    ></EffectiveDateDivWithIcon>
                    <GreenCalendarDiv
                      test-attr="policy-change-green-calendar-icon"
                      onClick={() => {
                        setShowCalendar(!showCalendar);
                      }}
                    >
                      <GreenCalendar />
                    </GreenCalendarDiv>
                  </DatePickerRow>
                  <BelowEffectiveDateDiv>
                    <Text>
                      Your date must be between{' '}
                      {moment(minEffectiveDate, 'YYYY-MM-DD').format(
                        'MM/DD/YYYY'
                      )}{' '}
                      and{' '}
                      {moment(maxEffectiveDate, 'YYYY-MM-DD').format(
                        'MM/DD/YYYY'
                      )}
                    </Text>
                  </BelowEffectiveDateDiv>
                  {showCalendar ? (
                    <DatePickerModalBackground
                      onClick={() => {
                        setShowCalendar(false);
                      }}
                    >
                      <DatePickerWrapper>
                        <DatePicker
                          setDate={setEffectiveDate}
                          minDate={minEffectiveDate}
                          maxDate={maxEffectiveDate}
                          onClickCancel={() => setShowCalendar(false)}
                        />
                      </DatePickerWrapper>
                    </DatePickerModalBackground>
                  ) : (
                    <></>
                  )}
                </InputGroup>)}
                {(showRenewal && !migrated) && (
                  <CheckboxOverallContainer test-attr="policy-change-renewal-options">

                    {effectiveDtRenewalError && (<Label
                      active={false}
                      showError={effectiveDtRenewalError}
                    >
                      Please verify effective date and the term selected.
                    </Label>)}
                    {renewalTermError && (<Label
                      active={false}
                      showError={renewalTermError}
                    >
                      At least one term is required.
                    </Label>)}
                    <CheckboxLabel
                    >
                      Apply to Policy term:
                    </CheckboxLabel>
                    <CheckboxIndividualContainer>
                      <CheckboxContainer>
                        <Checkbox
                          test-attr="policy-change-renewal-option-1"
                          type="checkbox"
                          defaultChecked={renewalTerms[0].isSelected}
                          disabled={renewalTerms[0].isDisabled}
                          onChange={() => {
                            renewalTerms[0].isSelected = !renewalTerms[0].isSelected;
                            setapplyChangeToRenewal(prevState =>
                              prevState.map((state, index) =>
                                index === 0 ? !state : state
                              )
                            );
                            validateRenewalTerm();
                            validateEffectiveDate();
                          }}
                        />
                      </CheckboxContainer>
                      <CheckboxText>{renewalTerms[0].textDate}</CheckboxText>
                    </CheckboxIndividualContainer>
                    {renewalTerms.length>1 && <CheckboxIndividualContainer>
                      <CheckboxContainer>
                        <Checkbox
                          test-attr="policy-change-renewal-option-1"
                          type="checkbox"
                          defaultChecked={renewalTerms[1].isSelected}
                          disabled={renewalTerms[1].isDisabled}
                          onChange={() => {
                            renewalTerms[1].isSelected = !renewalTerms[1].isSelected;
                            setapplyChangeToRenewal(prevState =>
                              prevState.map((state, index) =>
                                index === 1 ? !state : state
                              )
                            );
                            validateRenewalTerm();
                            validateEffectiveDate();
                          }}
                        />
                      </CheckboxContainer>
                      <CheckboxText>{renewalTerms[1].textDate}</CheckboxText>
                    </CheckboxIndividualContainer>}
                  </CheckboxOverallContainer>
                )}
                {(line === 'CA7Line' || line === 'CULine' || line === 'BP7Line') && (
                  <div>
                    <CheckboxLabel
                    >
                      What type of changes would you like to make? (check all that apply)
                    </CheckboxLabel>
                    {line === 'BP7Line' ? (
                      <CheckboxOverallContainer test-attr="policy-change-businessowners-options">
                        <CheckboxIndividualContainer>
                          <CheckboxContainer>
                            <Checkbox
                              test-attr="policy-change-businessowners-option-1"
                              type="checkbox"
                              onChange={() => {
                                setBusinessOwnersChangeChoices(prevState =>
                                  prevState.map((state, index) =>
                                    index === 0 ? !state : state
                                  )
                                );
                              }}
                            />
                          </CheckboxContainer>
                          <CheckboxText>Business Information</CheckboxText>
                        </CheckboxIndividualContainer>
                        <CheckboxIndividualContainer>
                          <CheckboxContainer>
                            <Checkbox
                              test-attr="policy-change-businessowners-option-2"
                              type="checkbox"
                              onChange={() => {
                                setBusinessOwnersChangeChoices(prevState =>
                                  prevState.map((state, index) =>
                                    index === 1 ? !state : state
                                  )
                                );
                              }}
                            />
                          </CheckboxContainer>
                          <CheckboxText>Industry/Classification Types</CheckboxText>
                        </CheckboxIndividualContainer>
                        <CheckboxIndividualContainer>
                          <CheckboxContainer>
                            <Checkbox
                              test-attr="policy-change-businessowners-option-3"
                              type="checkbox"
                              onChange={() => {
                                setBusinessOwnersChangeChoices(prevState =>
                                  prevState.map((state, index) =>
                                    index === 2 ? !state : state
                                  )
                                );
                              }}
                            />
                          </CheckboxContainer>
                          <CheckboxText>
                            Location, Building, or Classification Details
                          </CheckboxText>
                        </CheckboxIndividualContainer>
                        <CheckboxIndividualContainer>
                          <CheckboxContainer>
                            <Checkbox
                              test-attr="policy-change-businessowners-option-4"
                              type="checkbox"
                              onChange={() => {
                                setBusinessOwnersChangeChoices(prevState =>
                                  prevState.map((state, index) =>
                                    index === 3 ? !state : state
                                  )
                                );
                              }}
                            />
                          </CheckboxContainer>
                          <CheckboxText>
                            Limits, Coverages, or Deductibles
                          </CheckboxText>
                        </CheckboxIndividualContainer>
                        <CheckboxIndividualContainer>
                          <CheckboxContainer>
                            <Checkbox
                              test-attr="policy-change-businessowners-option-5"
                              type="checkbox"
                              onChange={() => {
                                setBusinessOwnersChangeChoices(prevState =>
                                  prevState.map((state, index) =>
                                    index === 4 ? !state : state
                                  )
                                );
                              }}
                            />
                          </CheckboxContainer>
                          <CheckboxText>Other</CheckboxText>
                        </CheckboxIndividualContainer>
                      </CheckboxOverallContainer>
                    ) : (<CheckboxOverallContainer test-attr="policy-change-businessowners-options">
                      <CheckboxIndividualContainer>
                        <CheckboxContainer>
                          <Checkbox
                            test-attr="policy-change-businessowners-option-1"
                            type="checkbox"
                            onChange={() => {
                              setBusinessOwnersChangeChoices(prevState =>
                                prevState.map((state, index) =>
                                  index === 0 ? !state : state
                                )
                              );
                            }}
                          />
                        </CheckboxContainer>
                        <CheckboxText>Business Information</CheckboxText>
                      </CheckboxIndividualContainer>
                      <CheckboxIndividualContainer>
                        <CheckboxContainer>
                          <Checkbox
                            test-attr="policy-change-businessowners-option-2"
                            type="checkbox"
                            onChange={() => {
                              setBusinessOwnersChangeChoices(prevState =>
                                prevState.map((state, index) =>
                                  index === 1 ? !state : state
                                )
                              );
                            }}
                          />
                        </CheckboxContainer>
                        <CheckboxText>Vehicles or Garaging Locations</CheckboxText>
                      </CheckboxIndividualContainer>
                      <CheckboxIndividualContainer>
                        <CheckboxContainer>
                          <Checkbox
                            test-attr="policy-change-businessowners-option-3"
                            type="checkbox"
                            onChange={() => {
                              setBusinessOwnersChangeChoices(prevState =>
                                prevState.map((state, index) =>
                                  index === 2 ? !state : state
                                )
                              );
                            }}
                          />
                        </CheckboxContainer>
                        <CheckboxText>
                          Drivers
                        </CheckboxText>
                      </CheckboxIndividualContainer>
                      <CheckboxIndividualContainer>
                        <CheckboxContainer>
                          <Checkbox
                            test-attr="policy-change-businessowners-option-4"
                            type="checkbox"
                            onChange={() => {
                              setBusinessOwnersChangeChoices(prevState =>
                                prevState.map((state, index) =>
                                  index === 3 ? !state : state
                                )
                              );
                            }}
                          />
                        </CheckboxContainer>
                        <CheckboxText>
                          Limits, Coverages, or Deductibles
                        </CheckboxText>
                      </CheckboxIndividualContainer>
                      <CheckboxIndividualContainer>
                        <CheckboxContainer>
                          <Checkbox
                            test-attr="policy-change-businessowners-option-5"
                            type="checkbox"
                            onChange={() => {
                              setBusinessOwnersChangeChoices(prevState =>
                                prevState.map((state, index) =>
                                  index === 4 ? !state : state
                                )
                              );
                            }}
                          />
                        </CheckboxContainer>
                        <CheckboxText>Other</CheckboxText>
                      </CheckboxIndividualContainer>
                    </CheckboxOverallContainer>)}
                  </div>
                )}
                {!isMarketUmbrella && (<InputGroup alignLastItemRight>
                  {documentNeeded || isFarmPolicy ? (
                    <>
                      <TextArea
                        maxLength={250}
                        showError={showDescriptionError}
                        onFocus={() => setDescriptionSelected(true)}
                        onBlur={() => setDescriptionSelected(false)}
                        value={description}
                        onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
                          setDescription(e.target.value.replace(/\n/g, ''));
                        }}
                        test-attr="policy-change-description-text-area"
                        placeholder="Please tell us the reason for policy change. (required)"
                      />
                      <Text>{description.length}/250</Text>
                    </>
                  ) : (
                    <>
                      <Label
                        active={descriptionInputSelected}
                        showError={showDescriptionError}
                      >
                        Description
                      </Label>
                      <Input
                        onFocus={() => setDescriptionSelected(true)}
                        onBlur={() => setDescriptionSelected(false)}
                        value={description}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                          setDescription(e.target.value);
                        }}
                        test-attr="policy-change-description-input"
                      />
                      {/* <DescriptionTextOptional>
                        Optional
                      </DescriptionTextOptional> */}
                    </>
                  )}
                </InputGroup>)}
                {(documentNeeded || isMarketUmbrella) && (
                  <DocumentBox>
                    <DocumentName
                      showError={showDocumentError}
                      test-attr="policy-change-document-name"
                    >
                      <Label
                        active={documentInputSelected}
                        showError={showDocumentError}
                      >
                        Document
                      </Label>
                      {file?.name ? (
                        <DocumentText test-attr="policy-change-file-name">
                          {file.name.length > 25
                            ? `${file.name.substring(0, 25)}...`
                            : file.name}
                        </DocumentText>
                      ) : (
                        <div />
                      )}
                    </DocumentName>
                    <SelectButton htmlFor="file">
                      <SelectFiles
                        type="file"
                        name="file"
                        id="file"
                        accept=".pdf, image/*"
                        onChange={e => {
                          const files: FileList | null | undefined =
                            e?.target?.files;
                          if (files && files.length) {
                            setFile(files[0]);
                          }
                        }}
                        test-attr="policy-change-file-input"
                      />
                      Browse
                    </SelectButton>
                  </DocumentBox>
                )}
                {(isMarketUmbrella) && (<div>
                  <InputGroup test-attr="cancel-policy-document-security-type">
                    <SelectorContainer>
                      <SecuritySelector
                        type="radio"
                        name="SecurityType"
                        value="sensitive"
                        checked={securityType === 'sensitive'}
                        onChange={() => {
                          setSecurityType('sensitive');
                        }}
                      />
                      <SecurityOption>Send to State Auto Only</SecurityOption>
                    </SelectorContainer>
                    <SelectorContainer>
                      <SecuritySelector
                        type="radio"
                        name="SecurityType"
                        value="unrestricted"
                        checked={securityType === 'unrestricted'}
                        onChange={() => setSecurityType('unrestricted')}
                      />
                      <SecurityOption>Send to Customer and State Auto</SecurityOption>
                    </SelectorContainer>
                  </InputGroup>
                </div>)}
                {renewalDate && !documentNeeded && (
                  <PolicyTermContainer test-attr="policy-change-term-container">
                    <PolicyTermInfoWrap>
                      <InfoIcon />
                      <PolicyTermInfoText test-attr="policy-change-term-info-test">
                        The renewal term begins on&nbsp;
                        <b>{formatDate(renewalDate)}</b>
                      </PolicyTermInfoText>
                    </PolicyTermInfoWrap>
                    <PolicyTermTitle>
                      Apply the policy change to
                    </PolicyTermTitle>
                    {policyTermOptionsArr.map(option => (
                      <PolicyTermOption key={option}>
                        <PolicyTermOptionsRadio
                          id={option.replace(' ', '_')}
                          type="radio"
                          name="Policy_Term_Option"
                          value={option}
                          checked={option === policyTerm}
                          onChange={() => setPolicyTerm(option)}
                        />
                        <PolicyTermOptionsLabel
                          htmlFor={option.replace(' ', '_')}
                        >
                          {option}
                        </PolicyTermOptionsLabel>
                      </PolicyTermOption>
                    ))}
                  </PolicyTermContainer>
                )}
                <ButtonContainer>
                  <CancelButton
                    type="button"
                    onClick={() => {
                      setEffectiveDate('');
                      setDescription('');
                      setFile(null);
                      setErrors({});
                      setSecurityType('');
                      simpleGTMDataLayer({
                        event: 'cancelPolicyChangeDropdownClick',
                        event_action: 'Button Click',
                        event_category: window.location.pathname,
                        event_label: 'cancelChangePolicyDropdown'
                      });
                      simpleGTMDataLayer({
                        event: 'cancelPolicyChangeDropdownClickSnowplow',
                        event_action: 'Button Click',
                        event_category: window.location.pathname + '/Snowplow',
                        event_label: 'cancelChangePolicyDropdown'
                      });
                    }}
                    test-attr="policy-change-cancel-button"
                  >
                    CANCEL
                  </CancelButton>
                  {isLoading ? (
                    <Loading>
                      <img src={spinnerLight} alt="spinner" />
                      <span>{spinnerText}</span>
                    </Loading>
                  ) : (
                    <StartChangeButton
                      test-attr="policy-change-start-change-button"
                      type="button"
                      onClick={async () => {
                        if (activePolicyChanges && !isWorkerCompLine && !isCppLine) {
                          setShowError(true);
                        } else if (documentNeeded) {
                          await uploadDocumentAndChangePolicy();
                        } else if (isMarketUmbrella) {
                          uploadDocumentForChange();
                        } else {
                          makeAPolicyChange();
                        }
                      }}
                    >{
                        isMarketUmbrella ? `UPLOAD` : `START CHANGE`
                      }


                    </StartChangeButton>
                  )}
                </ButtonContainer>
              </div>
            )}
          </>
        )}
      </ChangeForm>
    </div>
  );
};
